/** Education and work entries are shown oldest first. */
export const sortByStartDate = (data: any[] | undefined) => Array.isArray(data)
    ? [...data].sort((a, b) => new Date(a.from).getTime() - new Date(b.from).getTime())
    : null;
